<template>
  <div
      :data-dusk="dataDusk"
      @click="$emit('click', $event)"
      @click.self="$emit('on-self-click', $event)"
      :class="[
          'card flex-col shadow-sm',
          !wideContent ? 'container-v-lg container-h-lg' : '',
          nested ? 'nested' : '',
          active ? 'active' : '',
          clickable ? 'clickable' : ''
      ]"
  >
    <div>
      <slot name="header"></slot>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: "Card",
  props: {
    wideContent: {
      default: false,
      required: false,
      type: Boolean,
    },
    dataDusk: {
      required: false,
      type: String,
    },
    nested: {
      default: false,
      required: false,
      type: Boolean,
    },
    active: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  computed: {
    clickable() {
      return this.$listeners && this.$listeners.click;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

.has-link {
  &:hover {
    box-shadow: $shadow-xl;
  }
}

.card {
  background-color: white;
  border-radius: $border-radius-base;
  width: 100%;
  overflow: clip;
  color: $text-color;
  &.clickable {
    transition: all .1s ease-in-out;
    cursor: pointer;
    &:hover {
      transform: translateY(-2px);
      box-shadow: $shadow-lg;
    }
  }
}

.nested {
  background-color: $main-content-bg-color;
  box-shadow: none;
}

.active {
  outline: 2px solid $brand-primary;
  color: $brand-primary !important;
  fill: $brand-primary !important;
}
.content {
  transition: $transition-base;
  flex: 1;
  display: flex;
  flex-direction: column;
  opacity: 1;
}
</style>
